import chatIcon from '../assets/images/chat.svg'
import { useNavigate } from 'react-router'
import * as uuidAgent from 'short-uuid'
import { GoogleLogin } from '@react-oauth/google'
import { jwtDecode } from 'jwt-decode'
import Axios from 'axios'
import { useEffect } from 'react'

const Start = () => {
  const navigate = useNavigate()

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential)
      const response = await Axios.post(process.env.REACT_APP_API_BASE_URL + '/api/auth/google', {
        token: credentialResponse.credential,
      })
      localStorage.setItem(
        'user',
        JSON.stringify({
          username: decoded.name,
          avatar: decoded.picture,
          uuid: uuidAgent.generate(),
          email: decoded.email,
          googleId: decoded.sub,
        })
      )

      navigate('/chat')
    } catch (error) {
      console.log('Error processing Google auth:', error)

      const alertBox = document.getElementById('alertBox')
      if (alertBox) {
        if (error.response && error.response.status === 403) {
          alertBox.querySelector('p').textContent = 'You have been banned from this platform.'
        } else {
          alertBox.querySelector('p').textContent = 'Authentication failed!'
        }
        progressBar()
      }
    }
  }

  const progressBar = () => {
    const elem = document.getElementById('progressBar')
    const alertBox = document.getElementById('alertBox')
    alertBox.style.display = 'block'

    let width = 0
    const id = setInterval(frame, 15)

    function frame() {
      if (width >= 100) {
        clearInterval(id)
        alertBox.style.display = 'none'
      } else {
        width += 1
        elem.style.width = width + '%'
      }
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('banned') === 'true') {
      const alertBox = document.getElementById('alertBox')
      if (alertBox) {
        alertBox.querySelector('p').textContent = 'Your have been banned from this platform.'
        progressBar()
      }

      window.history.replaceState({}, document.title, window.location.pathname)
    }
  }, [])

  return (
    <div className="flex flex-col items-center justify-center h-full text-[#1687A7] z-0">
      <img src={chatIcon} alt="chat icon" className="left-2 top-1.5 absolute" />
      <div className="text-[1.5rem] p-[1.5rem]">Welcome!</div>

      <div className="mb-4 w-[18rem]">
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={() => {
            const alertBox = document.getElementById('alertBox')
            if (alertBox) {
              alertBox.querySelector('p').textContent = 'Google sign-in failed!'
              progressBar()
            }
          }}
          size="large"
          width="100%"
          text="signin_with"
          shape="rectangular"
        />
      </div>

      <div className="text-center justify-center bottom-[2.25rem] absolute">Chat With SDSLabs</div>
      <div
        id="alertBox"
        className="fixed top-10 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 w-80 z-50"
        style={{ display: 'none' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>

        <p id="alertMessage" className="text-sm font-medium">
          Authentication failed!
        </p>

        <div
          id="progressBar"
          className="absolute bottom-0 left-0 w-0 h-1 bg-red-700 rounded transition-all duration-300"
        ></div>
      </div>
    </div>
  )
}

export default Start
